/**
 * Error Exports
 *
 * Standardized error handling for Bash.
 */

export { ErrorCode, ErrorMessages, type ErrorCodeType } from './error-codes.js';

export {
  BashError,
  type BashErrorContext,
  type SerializedBashError,
  sessionNotFoundError,
  agentNotConnectedError,
  agentBusyError,
  validationError,
  socketNotConnectedError,
  envValidationError,
} from './base-error.js';
